import update from "immutability-helper";

import {
  SET_USER_INPUT,
  SEARCH_STARTED,
  SEARCH_SUCCESS,
  SEARCH_FAILURE,
  SEARCH_ABORTED,
  DELETE_CONFIRM,
  DELETE_STARTED,
  DELETE_SUCCESS,
  DELETE_FAILURE,
  DELETE_ABORTED,
} from "@js/actions/suppressed_address_search/actions.js";

export default (state = {}, action) => {
  switch (action.type) {
  case SET_USER_INPUT:
    return update(state, {
      userInput: { $set: action.value },
    });
  case SEARCH_STARTED:
    return update(state, {
      searching: { $set: true },
      error:     { $set: null },
      results:   { $set: null },
    });
  case SEARCH_SUCCESS:
    return update(state, {
      searching: { $set: false },
      error:     { $set: null },
      results:   { $set: action.data.addresses },
    });
  case SEARCH_FAILURE:
    return update(state, {
      searching: { $set: false },
      error:     { $set: action.error },
      results:   { $set: null },
    });
  case SEARCH_ABORTED:
    return update(state, {
      searching: { $set: false },
      error:     { $set: null },
      results:   { $set: null },
    });
  case DELETE_CONFIRM:
    return update(state, {
      confirmDelete:     { $set: true },
      confirmDeleteID:   { $set: action.id },
      confirmDeleteName: { $set: action.name },
      deleteStarted:     { $set: false },
    });
  case DELETE_STARTED:
    return update(state, {
      deleteStarted:     { $set: true },
    });
  case DELETE_FAILURE:
    return update(state, {
      deleteStarted:     { $set: false },
      deleteError:       { $set: action.error },
    });
  case DELETE_SUCCESS: {
    let newResults = state.results.filter((address) => address.id !== action.id);

    return update(state, {
      confirmDelete:     { $set: false },
      confirmDeleteID:   { $set: null },
      confirmDeleteName: { $set: null },
      deleteStarted:     { $set: false },
      results:           { $set: newResults },
    });
  }
  case DELETE_ABORTED:
    return update(state, {
      confirmDelete:     { $set: false },
      confirmDeleteID:   { $set: null },
      confirmDeleteName: { $set: null },
      deleteStarted:     { $set: false },
    });
  default:
    return state;
  }
};
